<app-standard-page>
  <router-outlet></router-outlet>
</app-standard-page>
